<template>
  <div class="row">
    <div class="col-12 q-pa-xs">
      <q-card flat bordered>
        <div class="row q-pa-md">
          <div class="col-12">
            <h6 class="q-my-none q-mt-xs">Xero Settings</h6>
          </div>
          <div class="col-6 q-pa-xs">
            <autocomplete
              dense
              label="Xero Tracking Options"
              :items="trackingOptionsList"
              :itemsLoading="trackingOptionsListLoading"
              option_label="name"
              option_value="id"
              :id="formData.xeroTrackingOptions_id"
              @changed="val => (formData.xeroTrackingOptions_id = val)"
            />
          </div>
          <div class="col-6 q-pa-xs">
            <autocomplete
              dense
              label="Sport Revenue Code"
              :items="sportRevenueCodeList"
              :itemsLoading="sportRevenueCodeListLoading"
              option_label="name"
              option_value="id"
              :id="formData.xeroSportRevenueCodes"
              @changed="val => (formData.xeroSportRevenueCodes = val)"
            />
          </div>
        </div>
      </q-card>
    </div>
    <div class="col-12 col-md-6 q-pa-xs">
      <q-card flat bordered>
        <div class="row q-pa-md">
          <div class="col-12">
            <h6 class="q-my-none q-mt-xs">Competition Fees (Required)</h6>
          </div>
          <div class="col-6 q-pa-xs">
            <q-input
              prefix="$"
              dense
              v-model="formData.compEarlyEntry"
              label="Early Entry *"
              fill-mask="0"
              v-bind="siteCFG.fields.general"
            />
          </div>
          <div class="col-6"></div>
          <div class="col-6 q-pa-xs">
            <q-input
              prefix="$"
              dense
              v-model="formData.compStandardEntry"
              label="Standard Entry *"
              fill-mask="0"
              v-bind="siteCFG.fields.general"
            />
          </div>
          <div class="col-6 q-pa-xs">
            <q-input
              dense
              label="Apply after date *"
              v-bind="siteCFG.fields.general"
              v-model="formData.compStandardEntryDate"
            >
              <template v-slot:append>
                <q-icon name="event" class="cursor-pointer">
                  <q-popup-proxy
                    transition-show="scale"
                    transition-hide="scale"
                  >
                    <q-date
                      v-model="formData.compStandardEntryDate"
                      mask="YYYY-MM-DD"
                    >
                      <div class="row items-center justify-end">
                        <q-btn
                          v-close-popup
                          label="Close"
                          color="primary"
                          flat
                        />
                      </div>
                    </q-date>
                  </q-popup-proxy>
                </q-icon>
              </template>
            </q-input>
          </div>
          <div class="col-6 q-pa-xs">
            <q-input
              prefix="$"
              dense
              v-model="formData.compLateEntry"
              label="Late Entry *"
              fill-mask="0"
              v-bind="siteCFG.fields.general"
            />
          </div>
          <div class="col-6 q-pa-xs">
            <q-input
              dense
              label="Apply after date *"
              v-bind="siteCFG.fields.general"
              v-model="formData.compLateEntryDate"
            >
              <template v-slot:append>
                <q-icon name="event" class="cursor-pointer">
                  <q-popup-proxy
                    transition-show="scale"
                    transition-hide="scale"
                  >
                    <q-date
                      v-model="formData.compLateEntryDate"
                      mask="YYYY-MM-DD"
                    >
                      <div class="row items-center justify-end">
                        <q-btn
                          v-close-popup
                          label="Close"
                          color="primary"
                          flat
                        />
                      </div>
                    </q-date>
                  </q-popup-proxy>
                </q-icon>
              </template>
            </q-input>
          </div>
        </div>
      </q-card>
    </div>
    <div class="col-12 col-md-6 q-pa-xs">
      <q-card style="height: 100%" flat bordered>
        <div class="row q-pa-md">
          <div class="col-12">
            <h6 class="q-my-none q-mt-xs">Per Event (Required)</h6>
          </div>
          <div class="col-6 col-md-4 q-pa-xs">
            <q-input
              prefix="$"
              dense
              v-model="formData.eventEarlyEntryInd"
              label="Early Entry Individual *"
              fill-mask="0"
              v-bind="siteCFG.fields.general"
            />
          </div>
          <div class="col-6 col-md-4 q-pa-xs">
            <q-input
              prefix="$"
              dense
              v-model="formData.eventEarlyEntryTeam"
              label="Early Entry Team *"
              fill-mask="0"
              v-bind="siteCFG.fields.general"
            />
          </div>
          <div class="col-12 col-md-4"></div>
          <div class="col-12 q-px-xs q-my-none">
            <!-- <q-input
              label="Competition Start Date"
              v-bind="siteCFG.fields.general"
              v-model="formData.earlyEntryDate"
            >
              <template v-slot:append>
                <q-icon name="event" class="cursor-pointer">
                  <q-popup-proxy
                    transition-show="scale"
                    transition-hide="scale"
                  >
                    <q-date
                      v-model="formData.earlyEntryDate"
                      mask="YYYY-MM-DD"
                    >
                      <div class="row items-center justify-end">
                        <q-btn
                          v-close-popup
                          label="Close"
                          color="primary"
                          flat
                        />
                      </div>
                    </q-date>
                  </q-popup-proxy>
                </q-icon>
              </template>
            </q-input> -->
          </div>
          <div class="col-6 col-md-4 q-pa-xs">
            <q-input
              prefix="$"
              dense
              v-model="formData.eventStandardEntryInd"
              label="Standard Entry Individual *"
              fill-mask="0"
              v-bind="siteCFG.fields.general"
            />
          </div>
          <div class="col-6 col-md-4 q-pa-xs">
            <q-input
              prefix="$"
              dense
              v-model="formData.eventStandardEntryTeam"
              label="Standard Entry Team *"
              fill-mask="0"
              v-bind="siteCFG.fields.general"
            />
          </div>
          <div class="col-12 col-md-4 q-pa-xs">
            <q-input
              dense
              label="Apply after date *"
              v-bind="siteCFG.fields.general"
              v-model="formData.eventStandardEntryDate"
            >
              <template v-slot:append>
                <q-icon name="event" class="cursor-pointer">
                  <q-popup-proxy
                    transition-show="scale"
                    transition-hide="scale"
                  >
                    <q-date
                      v-model="formData.eventStandardEntryDate"
                      mask="YYYY-MM-DD"
                    >
                      <div class="row items-center justify-end">
                        <q-btn
                          v-close-popup
                          label="Close"
                          color="primary"
                          flat
                        />
                      </div>
                    </q-date>
                  </q-popup-proxy>
                </q-icon>
              </template>
            </q-input>
          </div>
          <div class="col-6 col-md-4 q-pa-xs">
            <q-input
              prefix="$"
              dense
              v-model="formData.eventLateEntryInd"
              label="Late Entry Individual *"
              fill-mask="0"
              v-bind="siteCFG.fields.general"
            />
          </div>
          <div class="col-6 col-md-4 q-pa-xs">
            <q-input
              prefix="$"
              dense
              v-model="formData.eventLateEntryTeam"
              label="Late Entry Team *"
              fill-mask="0"
              v-bind="siteCFG.fields.general"
            />
          </div>
          <div class="col-12 col-md-4 q-pa-xs">
            <q-input
              dense
              label="Apply after date *"
              v-bind="siteCFG.fields.general"
              v-model="formData.eventLateEntryDate"
            >
              <template v-slot:append>
                <q-icon name="event" class="cursor-pointer">
                  <q-popup-proxy
                    transition-show="scale"
                    transition-hide="scale"
                  >
                    <q-date
                      v-model="formData.eventLateEntryDate"
                      mask="YYYY-MM-DD"
                    >
                      <div class="row items-center justify-end">
                        <q-btn
                          v-close-popup
                          label="Close"
                          color="primary"
                          flat
                        />
                      </div>
                    </q-date>
                  </q-popup-proxy>
                </q-icon>
              </template>
            </q-input>
          </div>
        </div>
      </q-card>
    </div>
    <div class="col-12 q-pa-xs">
      <q-card flat bordered>
        <div class="row q-pa-md">
          <div class="col-12">
            <h6 class="q-my-none q-mt-xs">
              Additional
              <q-btn
                icon="mdi-plus"
                flat
                color="black"
                @click="addAdditionalFee"
                :loading="addingAdditionalFee"
              ></q-btn>
            </h6>
          </div>
          <div class="col-12" style="height: 285px">
            <datatable
              :filter="additionalFeesSearch"
              :flat="true"
              :data="additionalFees"
              :columns="additionalFeesColumns"
            >
              <template slot="body-cell-ammt" slot-scope="data">
                <q-td :props="data.props">
                  <q-input
                    prefix="$"
                    v-model="data.props.row.ammt"
                    v-bind="siteCFG.fields.general"
                    @blur="saveAdditionalFromGrid(data.props.row)"
                    dense
                  />
                </q-td>
              </template>
              <template
                slot="body-cell-xeroSportRevenueCodes"
                slot-scope="data"
              >
                <q-td :props="data.props">
                  <autocomplete
                    dense
                    label="Sports Revenue Code"
                    :items="sportRevenueCodeList"
                    :itemsLoading="sportRevenueCodeListLoading"
                    option_label="name"
                    option_value="id"
                    :id="data.props.row.xeroSportRevenueCodes"
                    @changed="
                      val => {
                        data.props.row.xeroSportRevenueCodes = val;
                        saveAdditionalFromGrid(data.props.row);
                      }
                    "
                  />
                </q-td>
              </template>

              <template slot="body-cell-desc" slot-scope="data">
                <q-td :props="data.props">
                  <q-input
                    v-model="data.props.row.desc"
                    v-bind="siteCFG.fields.general"
                    @blur="saveAdditionalFromGrid(data.props.row)"
                    dense
                  />
                </q-td>
              </template>
              <template slot="body-cell-athlete" slot-scope="data">
                <q-td :props="data.props">
                  <q-checkbox
                    v-model="data.props.row.athlete"
                    v-bind="siteCFG.fields.general"
                    :true-value="1"
                    :false-value="0"
                    dense
                    indeterminate-value="no-value"
                    @input="saveAdditionalFromGrid(data.props.row)"
                  />
                </q-td>
              </template>
              <template slot="body-cell-indEvent" slot-scope="data">
                <q-td :props="data.props">
                  <q-checkbox
                    v-model="data.props.row.indEvent"
                    v-bind="siteCFG.fields.general"
                    :true-value="1"
                    :false-value="0"
                    dense
                    indeterminate-value="no-value"
                    @input="saveAdditionalFromGrid(data.props.row)"
                  />
                </q-td>
              </template>
              <template slot="body-cell-teamEvent" slot-scope="data">
                <q-td :props="data.props">
                  <q-checkbox
                    v-model="data.props.row.teamEvent"
                    v-bind="siteCFG.fields.general"
                    :true-value="1"
                    :false-value="0"
                    dense
                    indeterminate-value="no-value"
                    @input="saveAdditionalFromGrid(data.props.row)"
                  />
                </q-td>
              </template>
              <template slot="body-cell-actions" slot-scope="data">
                <q-td :props="data.props">
                  <q-btn
                    @click="removeAdditionalFee(data.props.row.id)"
                    round
                    flat
                    color="negative"
                  >
                    <q-icon name="mdi-trash-can-outline"></q-icon>
                    <q-tooltip>Remove Additional Fee</q-tooltip>
                  </q-btn>
                </q-td>
              </template>
            </datatable>
          </div>
        </div>
      </q-card>
    </div>
    <div class="col-12 col-md-6 q-pa-xs">
      <q-card flat bordered>
        <div class="row q-pa-md">
          <div class="col-12">
            <h6 class="q-my-none q-mt-xs">
              <div class="row">
                <div style="width: 140px">Per Division</div>
                <div class="col">
                  <autocomplete
                    dense
                    label="Add Division"
                    :items="divisions"
                    :itemsLoading="divisionsLoading"
                    :excludeList="
                      divisionFees.map(ef => {
                        return { id: ef.divisions_id };
                      })
                    "
                    option_label="division_name"
                    option_value="id"
                    :id="newDivision_id"
                    @changed="val => (newDivision_id = val)"
                  />
                </div>
                <q-btn
                  :disable="!newDivision_id"
                  class="col col-auto"
                  style="width: 40px"
                  flat
                  icon="mdi-plus"
                  @click="addDivisionFee"
                  :loading="addingDivisionFee"
                ></q-btn>
              </div>
            </h6>
          </div>
          <div class="col-12" style="height: 235px">
            <datatable
              :filter="divisionFeesSearch"
              :flat="true"
              :data="divisionFees"
              :columns="divisionFeesColumns"
            >
              <template slot="body-cell-ammt" slot-scope="data">
                <q-td :props="data.props">
                  <q-input
                    prefix="$"
                    v-model="data.props.row.ammt"
                    v-bind="siteCFG.fields.general"
                    @blur="saveDivisionFromGrid(data.props.row)"
                    dense
                  />
                </q-td>
              </template>

              <template slot="body-cell-actions" slot-scope="data">
                <q-td :props="data.props">
                  <q-btn
                    @click="removeDivisionFee(data.props.row.id)"
                    round
                    flat
                    color="negative"
                  >
                    <q-icon name="mdi-trash-can-outline"></q-icon>
                    <q-tooltip>Remove Division Fee</q-tooltip>
                  </q-btn>
                </q-td>
              </template>
            </datatable>
          </div>
        </div>
      </q-card>
    </div>
    <div class="col-12 col-md-6 q-pa-xs">
      <q-card flat bordered>
        <div class="row q-pa-md">
          <div class="col-12">
            <h6 class="q-my-none q-mt-xs">
              <div class="row">
                <div style="width: 140px">Per Event</div>
                <div class="col">
                  <autocomplete
                    dense
                    label="Add Event"
                    :items="events"
                    :itemsLoading="eventsLoading"
                    :excludeList="
                      eventFees.map(ef => {
                        return { id: ef.events_id };
                      })
                    "
                    option_label="event_name"
                    option_value="id"
                    :id="newEvent_id"
                    @changed="val => (newEvent_id = val)"
                  />
                </div>
                <q-btn
                  :disable="!newEvent_id"
                  class="col col-auto"
                  style="width: 40px"
                  flat
                  icon="mdi-plus"
                  @click="addEventFee"
                  :loading="addingEventFee"
                ></q-btn>
              </div>
            </h6>
          </div>
          <div class="col-12" style="height: 235px">
            <datatable
              :filter="eventFeesSearch"
              :flat="true"
              :data="eventFees"
              :columns="eventFeesColumns"
            >
              <template slot="body-cell-ammt" slot-scope="data">
                <q-td :props="data.props">
                  <q-input
                    prefix="$"
                    v-model="data.props.row.ammt"
                    v-bind="siteCFG.fields.general"
                    @blur="saveEventFromGrid(data.props.row)"
                    dense
                  />
                </q-td>
              </template>

              <template slot="body-cell-actions" slot-scope="data">
                <q-td :props="data.props">
                  <q-btn
                    @click="removeEventFee(data.props.row.id)"
                    round
                    flat
                    color="negative"
                  >
                    <q-icon name="mdi-trash-can-outline"></q-icon>
                    <q-tooltip>Remove Event Fee</q-tooltip>
                  </q-btn>
                </q-td>
              </template>
            </datatable>
          </div>
        </div>
      </q-card>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import datatable from "@/components/datatable/datatable.vue";
import autocomplete from "@/components/wrappers/autocomplete/autocomplete.vue";

export default {
  components: { datatable, autocomplete },
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
      currentUserData: "auth/currentUserData",
      siteCFG: "settings/siteCFG",
      invoiceSettings: "competitionInvoiceSettings/current",
      invoiceSettingsLoading: "competitionInvoiceSettings/currentLoading",
      additionalFees: "competitionInvoiceSettings/additionalFees",
      additionalFeesLoading: "competitionInvoiceSettings/additionalFeesLoading",
      divisionFees: "competitionInvoiceSettings/divisionFees",
      divisionFeesLoading: "competitionInvoiceSettings/divisionFeesLoading",
      eventFees: "competitionInvoiceSettings/eventFees",
      eventFeesLoading: "competitionInvoiceSettings/eventFeesLoading",
      competition: "competitions/current",
      divisions: "divisions/listForCompetition",
      divisionsLoading: "divisions/listForCompetitionLoading",
      events: "events/listForCompetition",
      eventsLoading: "events/listForCompetitionLoading",
      sportRevenueCodeList: "xeroSettings/sportRevenueCodeList",
      sportRevenueCodeListLoading: "xeroSettings/sportRevenueCodeListLoading",
      trackingCategoriesList: "xeroSettings/trackingCategoriesList",
      trackingCategoriesListLoading:
        "xeroSettings/trackingCategoriesListLoading",
      trackingOptionsList: "xeroSettings/trackingOptionsList",
      trackingOptionsListLoading: "xeroSettings/trackingOptionsListLoading"
    })
  },

  data: () => ({
    formData: {
      compEarlyEntry: null,
      compEarlyEntryDate: null,
      compStandardEntry: null,
      compStandardEntryDate: null,
      compLateEntry: null,
      compLateEntryDate: null,

      eventEarlyEntryInd: null,
      eventEarlyEntryTeam: null,
      eventEarlyEntryDate: null,
      eventStandardEntryInd: null,
      eventStandardEntryTeam: null,
      eventStandardEntryDate: null,
      eventLateEntryInd: null,
      eventLateEntryTeam: null,
      eventLateEntryDate: null
    },

    // Additional Fees
    additionalFeesSearch: "",
    addingAdditionalFee: false,
    additionalFeesColumns: [
      {
        name: "ammt",
        label: "Ammount",
        align: "left",
        field: "ammt",
        style:
          "min-width: 150px;max-width: 150px;width:150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
        sortable: true
      },
      {
        name: "xeroSportRevenueCodes",
        label: "Sport Revenue Code",
        align: "left",
        field: "xeroSportRevenueCodes",
        style:
          "min-width: 300px;max-width: 300px;width:300px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
        sortable: true
      },
      {
        name: "desc",
        label: "Description",
        align: "left",
        field: "desc",
        style:
          "min-width: 350px;max-width: 350px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
        sortable: true
      },
      {
        name: "athlete",
        label: "Athlete",
        align: "left",
        field: "athlete",
        sortable: true
      },
      {
        name: "indEvent",
        label: "Individual Event",
        align: "left",
        field: "indEvent",
        style:
          "min-width: 150px;max-width: 150px;width:150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
        sortable: true
      },
      {
        name: "teamEvent",
        label: "Team Event",
        align: "left",
        field: "teamEvent",
        style:
          "min-width: 150px;max-width: 150px;width:150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
        sortable: true
      },

      {
        name: "actions",
        label: "Actions",
        align: "left",
        sortable: false
      }
    ],

    // Event Fees
    eventFeesSearch: "",
    newEvent_id: null,
    addingEventFee: false,
    eventFeesColumns: [
      {
        name: "event_name",
        label: "Event",
        align: "left",
        field: "event_name",
        style:
          "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
        sortable: true
      },
      {
        name: "ammt",
        label: "Ammount",
        align: "left",
        field: "ammt",
        style:
          "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
        sortable: true
      },
      {
        name: "actions",
        label: "Actions",
        align: "left",
        sortable: false
      }
    ],

    // Division Fees
    divisionFeesSearch: "",
    newDivision_id: null,
    addingDivisionFee: false,
    divisionFeesColumns: [
      {
        name: "division_name",
        label: "Division",
        align: "left",
        field: "division_name",
        style:
          "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
        sortable: true
      },
      {
        name: "ammt",
        label: "Ammount",
        align: "left",
        field: "ammt",
        style:
          "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
        sortable: true
      },
      {
        name: "actions",
        label: "Actions",
        align: "left",
        sortable: false
      }
    ]
  }),
  watch: {
    invoiceSettings: function() {
      this.init();
    }
  },
  created() {
    this.$store.dispatch("divisions/loadForCompetition", this.competition.id);
    this.$store.dispatch("xeroSettings/loadAllSportRevenueCodes");
    this.$store.dispatch("xeroSettings/loadAllTrackingCategories");
    this.$store.dispatch("xeroSettings/loadAllTrackingOptions");

    this.$store.dispatch(
      "competitionInvoiceSettings/loadForCompetition",
      this.competition.id
    );
    this.$store.dispatch(
      "competitionInvoiceSettings/loadAdditionalFees",
      this.competition.id
    );
    this.$store.dispatch(
      "competitionInvoiceSettings/loadDivisionFees",
      this.competition.id
    );
    this.$store.dispatch(
      "competitionInvoiceSettings/loadEventFees",
      this.competition.id
    );
  },
  mounted() {},
  methods: {
    init() {
      if (this.invoiceSettings) {
        this.formData = JSON.parse(JSON.stringify(this.invoiceSettings));
      } else {
        this.formData = {
          compEarlyEntry: null,
          compEarlyEntryDate: null,
          compStandardEntry: null,
          compStandardEntryDate: null,
          compLateEntry: null,
          compLateEntryDate: null,

          eventEarlyEntryInd: null,
          eventEarlyEntryTeam: null,
          eventEarlyEntryDate: null,
          eventStandardEntryInd: null,
          eventStandardEntryTeam: null,
          eventStandardEntryDate: null,
          eventLateEntryInd: null,
          eventLateEntryTeam: null,
          eventLateEntryDate: null
        };
      }
    },

    save() {
      let notNullFields = [
        "compEarlyEntry",
        "compStandardEntry",
        "compLateEntry",
        "eventEarlyEntryInd",
        "eventEarlyEntryTeam",
        "eventStandardEntryInd",
        "eventStandardEntryTeam",
        "eventLateEntryInd",
        "eventLateEntryTeam"
      ];
      notNullFields.forEach(element => {
        if (!this.formData[element]) {
          this.formData[element] = 0;
        }
      });
      this.$store
        .dispatch("competitionInvoiceSettings/save", this.formData)
        .then(result => {
          this.$store.dispatch(
            "xeroSettings/loadAllInvoiceObjects",
            this.competition.id
          );
          if (result.Result != "Success") {
            this.$q.notify({
              position: "top-right",
              type: "negative",
              message:
                "There was an Error saving invoice settings, Please try again later"
            });
          }
        });
    },

    // Additional Fees
    addAdditionalFee() {
      this.addingAdditionalFee = true;
      this.$store
        .dispatch("competitionInvoiceSettings/addAdditionalFee", {
          competitions_id: this.competition.id
        })
        .then(result => {
          this.addingAdditionalFee = false;
          this.$store.dispatch(
            "xeroSettings/loadAllInvoiceObjects",
            this.competition.id
          );

          if (result.Result == "Success") {
            this.$q.notify({
              position: "top-right",
              type: "positive",
              message: result.Response.Message
            });
          } else {
            this.$q.notify({
              position: "top-right",
              type: "negative",
              message: "There was an Error, Please try again later"
            });
          }
        });
    },
    saveAdditionalFromGrid(row) {
      this.$store
        .dispatch("competitionInvoiceSettings/saveAdditionalFee", row)
        .then(result => {
          this.$store.dispatch(
            "xeroSettings/loadAllInvoiceObjects",
            this.competition.id
          );

          if (result.Result == "Success") {
            this.$q.notify({
              position: "top-right",
              type: "positive",
              message: result.Response.Message
            });
          } else {
            this.$q.notify({
              position: "top-right",
              type: "negative",
              message: "There was an Error, Please try again later"
            });
          }
        });
    },
    removeAdditionalFee(id) {
      this.$swal({
        title: "Warning",
        text: "You are about to remove a fee, do you wish to continue?",
        type: "warning",
        confirmButtonText: "Confirm",
        cancelButtonText: "Cancel",
        showCancelButton: true,
        confirmButtonColor: "#f58122"
      }).then(res => {
        if (res.value) {
          this.$store
            .dispatch("competitionInvoiceSettings/deleteAdditionalFee", {
              id: id,
              competitions_id: this.competition.id
            })
            .then(result => {
              this.$store.dispatch(
                "xeroSettings/loadAllInvoiceObjects",
                this.competition.id
              );

              if (result.Result == "Success") {
                this.$q.notify({
                  position: "top-right",
                  type: "positive",
                  message: result.Response.Message
                });
              } else {
                this.$q.notify({
                  position: "top-right",
                  type: "negative",
                  message: "There was an Error, Please try again later"
                });
              }
            });
        }
      });
    },

    // Division Fees
    addDivisionFee() {
      this.addingDivisionFee = true;
      this.$store
        .dispatch("competitionInvoiceSettings/addDivisionFee", {
          divisions_id: this.newDivision_id,
          competitions_id: this.competition.id
        })
        .then(result => {
          this.addingDivisionFee = false;
          this.$store.dispatch(
            "xeroSettings/loadAllInvoiceObjects",
            this.competition.id
          );

          if (result.Result == "Success") {
            this.newDivision_id = null;
            this.$q.notify({
              position: "top-right",
              type: "positive",
              message: result.Response.Message
            });
          } else {
            this.$q.notify({
              position: "top-right",
              type: "negative",
              message: "There was an Error, Please try again later"
            });
          }
        });
    },
    saveDivisionFromGrid(row) {
      this.$store
        .dispatch("competitionInvoiceSettings/saveDivisionFee", row)
        .then(result => {
          this.$store.dispatch(
            "xeroSettings/loadAllInvoiceObjects",
            this.competition.id
          );
          if (result.Result == "Success") {
            this.$q.notify({
              position: "top-right",
              type: "positive",
              message: result.Response.Message
            });
          } else {
            this.$q.notify({
              position: "top-right",
              type: "negative",
              message: "There was an Error, Please try again later"
            });
          }
        });
    },
    removeDivisionFee(id) {
      this.$swal({
        title: "Warning",
        text: "You are about to remove a fee, do you wish to continue?",
        type: "warning",
        confirmButtonText: "Confirm",
        cancelButtonText: "Cancel",
        showCancelButton: true,
        confirmButtonColor: "#f58122"
      }).then(res => {
        if (res.value) {
          this.$store
            .dispatch("competitionInvoiceSettings/deleteDivisionFee", {
              id: id,
              competitions_id: this.competition.id
            })
            .then(result => {
              this.$store.dispatch(
                "xeroSettings/loadAllInvoiceObjects",
                this.competition.id
              );

              if (result.Result == "Success") {
                this.$q.notify({
                  position: "top-right",
                  type: "positive",
                  message: result.Response.Message
                });
              } else {
                this.$q.notify({
                  position: "top-right",
                  type: "negative",
                  message: "There was an Error, Please try again later"
                });
              }
            });
        }
      });
    },

    // Event Fees
    addEventFee() {
      this.addingEventFee = true;
      this.$store
        .dispatch("competitionInvoiceSettings/addEventFee", {
          events_id: this.newEvent_id,
          competitions_id: this.competition.id
        })
        .then(result => {
          this.addingEventFee = false;
          this.$store.dispatch(
            "xeroSettings/loadAllInvoiceObjects",
            this.competition.id
          );

          if (result.Result == "Success") {
            this.newEvent_id = null;
            this.$q.notify({
              position: "top-right",
              type: "positive",
              message: result.Response.Message
            });
          } else {
            this.$q.notify({
              position: "top-right",
              type: "negative",
              message: "There was an Error, Please try again later"
            });
          }
        });
    },
    saveEventFromGrid(row) {
      this.$store
        .dispatch("competitionInvoiceSettings/saveEventFee", row)
        .then(result => {
          this.$store.dispatch(
            "xeroSettings/loadAllInvoiceObjects",
            this.competition.id
          );

          if (result.Result == "Success") {
            this.$q.notify({
              position: "top-right",
              type: "positive",
              message: result.Response.Message
            });
          } else {
            this.$q.notify({
              position: "top-right",
              type: "negative",
              message: "There was an Error, Please try again later"
            });
          }
        });
    },
    removeEventFee(id) {
      this.$swal({
        title: "Warning",
        text: "You are about to remove a fee, do you wish to continue?",
        type: "warning",
        confirmButtonText: "Confirm",
        cancelButtonText: "Cancel",
        showCancelButton: true,
        confirmButtonColor: "#f58122"
      }).then(res => {
        if (res.value) {
          this.$store
            .dispatch("competitionInvoiceSettings/deleteEventFee", {
              id: id,
              competitions_id: this.competition.id
            })
            .then(result => {
              this.$store.dispatch(
                "xeroSettings/loadAllInvoiceObjects",
                this.competition.id
              );

              if (result.Result == "Success") {
                this.$q.notify({
                  position: "top-right",
                  type: "positive",
                  message: result.Response.Message
                });
              } else {
                this.$q.notify({
                  position: "top-right",
                  type: "negative",
                  message: "There was an Error, Please try again later"
                });
              }
            });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>
